<template>
  <div>
    <b-toast class="pwa-promotion" variant="warning" :title="$t('install')" v-model="showPwaPromotion" static no-auto-hide @hidden="hidePromotion"> {{ $t('pwaPromotion') }} <br /> <br /> <b-button @click="install" size="sm" variant="success"> {{ $t('install') }} </b-button></b-toast>
    
    <router-view></router-view>
    <portal-target name="main-dialog-portal" multiple />
    <portal-target name="editor-select-portal" multiple />
    <MainDialogHost />
    <kortex-quick-dialog />

    <!-- Global Log Export Modal -->
    <LogExportModal
      :include-screenshot="logExportModalConfig.includeScreenshot"
      :logs-count="logExportModalConfig.logsCount"
      :logs-size="logExportModalConfig.logsSize"
      @confirm="handleLogExportConfirm"
    />

    <!-- Global Support Ticket Dialog -->
    <CreateTicketDialog />

    <!-- Global Credit Topup Dialog -->
    <CreditTopupDialog />
  </div>
  
</template>

<script>
import LogExportModal from './components/utils/LogExportModal.vue';
import CreateTicketDialog from './components/integrations/protokol/support/CreateTicketDialog.vue';
import CreditTopupDialog from './components/billing/CreditTopupDialog.vue';
import KortexQuickDialog from './views/cortex/KortexQuickDialog';
import MainDialogHost from './components/MainDialogHost';

export default {
  name: 'app',
  components: {
    LogExportModal,
    CreateTicketDialog,
    CreditTopupDialog,
    KortexQuickDialog,
    MainDialogHost
  },
  data: function() {
    return {
      installPrompt: null,
      showPwaPromotion: false,
      ready: false,
      logExportModalConfig: {
        includeScreenshot: false,
        logsCount: 0,
        logsSize: '0 KB',
        callback: null
      }
    }
  },

  computed: {
    locale() {
        if (this.$route.query.lang) {
          return this.$route.query.lang
        }

        return this.$store.getters.getLocale
    },
  },

  methods: {
    install() {
      if (this.installPrompt) this.installPrompt.prompt();
    },

    hidePromotion() {
      localStorage.setItem('pwa_promotion', new Date())
    },

    handleLogExportConfirm(comment) {
      if (this.logExportModalConfig.callback) {
        this.logExportModalConfig.callback(true, comment);
      }
    },

    handleKortexKeyboard(e) {
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && !e.altKey && (e.code === 'KeyK' || e.key === 'k' || e.key === 'K')) {
        if (!this.$store.getters.isIntegrationActive('protokol-kortex')) return
        if (!this.$isAdmin() && !this.$store.state.cortex.myAccess) return
        e.preventDefault()
        this.$store.dispatch('cortex/toggleQuickDialog')
      }
    }
  },  

  created() {

    document.body.classList.add('sidebar-minimized');

    // Listen for log export modal events
    this.$root.$on('show-log-export-modal', (config) => {
      this.logExportModalConfig = {
        includeScreenshot: config.includeScreenshot,
        logsCount: config.logsCount,
        logsSize: config.logsSize,
        callback: config.callback
      };
      this.$mainDialog.show('log-export-modal');
    });

    // Handle modal cancel
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (modalId === 'log-export-modal' && bvEvent.trigger !== 'ok') {
        if (this.logExportModalConfig.callback) {
          this.logExportModalConfig.callback(false, '');
        }
      }
    });

    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevents the default mini-infobar or install dialog from appearing on mobile
      e.preventDefault();
      // Save the event because you'll need to trigger it later.
      this.installPrompt = e;
      // Show your customized install prompt for your PWA
      // Your own UI doesn't have to be a single element, you
      // can have buttons in different locations, or wait to prompt
      // as part of a critical journey.
      let promotion = localStorage.getItem('pwa_promotion')

      if (!promotion) {
        this.showPwaPromotion = true
      } else {
        let today = new Date()
        let hidden = new Date(promotion)

        const diffTime = Math.abs(today - hidden);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays > 7 && this.$route.path.startsWith("/admin")) {
          this.showPwaPromotion = true
        }
      }

    });
  },

  mounted() {
    document.addEventListener('keydown', this.handleKortexKeyboard, true)
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKortexKeyboard, true)
  }
}

</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss'; */
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
   @import 'assets/scss/style';

   .pwa-promotion {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 9999;
   }
</style>
